module.exports = __webpack_public_path__ + "8a93ebb20a73e3d5df3f347520c82cee.svg";